export * from './actions';
export * from './effects';
export * from './service';

export {
  featureKey as getCoveragesKey,
  initialState as getCoveragesInitialState,
  State as GetCoveragesState,
} from './reducer';

export {
  getData as getCoveragesGetData,
  getError as getCoveragesGetError,
  getLoading as getCoveragesGetLoading,
  mapData as getCoveragesMapData,
} from './selectors';
